import React, { useState } from 'react';
import logo from '../asset/bijonlogo.png'
import Reveal from 'react-reveal/Reveal';
import prodile from '../asset/bijon3.png'
import { Typewriter } from 'react-simple-typewriter'





import './Main.css'
import { Link, Outlet } from 'react-router-dom';
import { AiFillCode, AiFillFacebook, AiFillGithub, AiFillLinkedin, AiFillMediumCircle } from 'react-icons/ai';


const Main = () => {

  return (
    <Reveal>

      <div className='mainlayout'>
   
          <div className='sidebar bg-black h-screen'>
            <div className='flex justify-center pt-3 pb-3 '>
              <div className="avatar">
                <div className="w-36 rounded-full ring ring-primary ring-offset-base-100 ring-offset-2">
                  <img src={prodile} />
                </div>
              </div>
            </div>
            <hr />
            <div>
              <Link to='/'><div className='text-white text-2xl font-bold hover:bg-lime-800 p-[16px]'>HOME</div></Link>
              <Link to='/projects'><div className='text-white text-2xl font-bold hover:bg-lime-800 p-[16px]'>PROJECT</div></Link>

              <Link to='/about'><div className='text-white text-2xl font-bold hover:bg-lime-800 p-[16px]'>ABOUT</div></Link>
              <Link to='/contact'><div className='text-white text-2xl font-bold hover:bg-lime-800 p-[16px]'>CONTACT</div></Link>

             


            </div>
           
           
            <div className='fixed bottom-0 text-white w-[225px] p-3'>
         <hr/>
        <div className='flex justify-center pt-3'>
        <AiFillLinkedin size={20} />
          <AiFillGithub size={20} className='mx-4'/>
          <AiFillFacebook size={20} />


        </div>
            </div>

          </div>

       
        <div className='mainbody'>
         
          <Outlet/>






        </div>

      </div>

    </Reveal>
  );
};

export default Main;